<template>
  <div class="mapreview">
    <baidu-map
      class="mapre"
      :center="center"
      :zoom="zoom"
      :scroll-wheel-zoom="true"
      @ready="handler"
      :ak="ak"
    >
     <bm-marker
      :position="center"
      :dragging="true"
      animation="BMAP_ANIMATION_BOUNCE"
      :icon="{
        url: '../assets/markergif.gif',
        size: { width: 300, height: 157 },
      }"
    >
     <bm-label
      :content="labelstr"
      :labelStyle="{ color: 'gray', fontSize: '16px' }"
      :offset="{ width: -35, height: -30 }"
    />
    </bm-marker>
    </baidu-map>
   
   
  </div>
</template>

<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmGeolocation from "vue-baidu-map/components/controls/Geolocation.vue";
import BmLocalSearch from "vue-baidu-map/components/search/LocalSearch.vue";
import BmCircle from "vue-baidu-map/components/overlays/Circle.vue";
import BmMarker from "vue-baidu-map/components/overlays/Marker.vue";
import BmLabel from "vue-baidu-map/components/overlays/Label.vue";
import { Toast, Dialog } from "vant";
import { mapState } from "vuex";
import locationUtils from "../utils/geoTran.js";
import fetchJsonp from "fetch-jsonp";
import { error } from "console";
export default {
  name: "MapreView",
  components: {
    BaiduMap,
    BmMarker,
    BmLabel,
  },
  props: {
    position: {
      type: Object,
    },
  },
  data() {
    return {
      ak: "dcsylBb7nOrDMqsh0K0uekos9WoGGr8C",
      center: { lng: 114.044815, lat: 22.561407 },
      zoom: 18,
      BMap: null,
      map: null,
      labelstr:'',
    };
  },
  methods: {
    set_mapre_CSS() {
      let deviceNparam = window.screen;
      let w = window.document.body.offsetWidth;
      let h = window.document.body.offsetHeight;
      window.document.getElementsByClassName('mapre')[0].style.position="absolute";
      window.document.getElementsByClassName('mapre')[0].style.width=w+'px';
      window.document.getElementsByClassName('mapre')[0].style.height=h+'px';
    },
    handler({ BMap, map }) {
      let that = this;
      that.BMap = BMap;
      that.map = map;
      that.set_mapre_CSS();
      that.setMapCenter();
      var point = new BMap.Point(that.center.lng, that.center.lat);
      map.centerAndZoom(point, 15);
    },
    setMapCenter(){
        let that=this;
        that.center=that.point;
        console.log(that.address);
        that.labelstr=that.address.address;
    },
  },
  watch: {},
  computed: {
      ...mapState(["point", "address"]),
  },
  beforeCreate() {
    //console.log(1);
    //在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用
  },
  created() {
    //实例已经创建完成之后被调用。在这一步，实例已完成以下的配置：数据观测(data observer)，属性和方法的运算， watch/event 事件回调。
    //然而，挂载阶段还没开始，$el 属性目前不可见。
    //可以在组件的这个期间请求数据，如果是keep-alive组件会被缓存起来，生命周期不会再次触发，如果需要更新数据可以watch当前router变化，如果router是当前组件所在的router则请求数据
    //console.log(2);
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用
    //console.log(3);
  },
  mounted() {
    //vm.$el已挂载在文档内，对已有dom节点的操作可以在这期间进行
    //console.log(4);
    let that=this;
    
    window.onresize=function(){
        that.set_mapre_CSS();
    };
  },
  beforeUpdate() {
    //数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程
    //console.log(5);
  },
  updated() {
    //由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
    //当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。然而在大多数情况下，你应该避免在此期间更改状态，因为这可能会导致更新无限循环。
    //console.log(6);
  },
  activated() {
    //keep-alive 组件激活时调用
    //console.log(7);
  },
  deactivated() {
    //keep-alive 组件停用时调用
    //console.log(8);
  },
  beforeDestroy() {
    //实例销毁之前调用。在这一步，实例仍然完全可用
    //console.log(9);
  },
  destroyed() {
    //Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，所有的事件监听器会被移除，所有的子实例也会被销毁
    //console.log(10);
  },
};
</script>

<style>
</style>